import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONTYPES_LOAD,
    ACTION_INSTITUTIONTYPES_LOAD_BY_ID,

    ACTION_INSTITUTIONTYPES_SAVE,

    ACTION_INSTITUTIONTYPES_CREATE,

    ACTION_INSTITUTIONTYPES_VALIDATE,

    IInstitutionTypeLoadAction,
    IInstitutionTypeLoadByIdAction,
    IInstitutionTypeLoadFailureAction,
    IInstitutionTypeLoadSuccessAction,

    IInstitutionTypeSaveAction,
    IInstitutionTypeSaveSuccessAction,
    IInstitutionTypeSaveFailureAction,

    IInstitutionTypeCreateAction,
    IInstitutionTypeCreateSuccessAction,
    IInstitutionTypeCreateFailureAction,

    IInstitutionTypeValidateAction,
    IInstitutionTypeValidateSuccessAction,
    IInstitutionTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionTypes";
import { institutiontypesApi } from "../services/institutionType";


export const
    getInstitutionTypesEpic = (action$): Observable<IInstitutionTypeLoadSuccessAction | IInstitutionTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONTYPES_LOAD)
            .mergeMap((_action: IInstitutionTypeLoadAction) => {
                return institutiontypesApi
                    .getInstitutionTypes()
                    .map(response =>
                        LoadSuccess(response.institutionTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionTypeByIdEpic = (action$): Observable<IInstitutionTypeLoadSuccessAction | IInstitutionTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONTYPES_LOAD_BY_ID)
            .mergeMap((action: IInstitutionTypeLoadByIdAction) => {
                return institutiontypesApi
                    .getInstitutionTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionTypeEpic = (action$): Observable<IInstitutionTypeSaveSuccessAction | IInstitutionTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONTYPES_SAVE)
            .mergeMap((action: IInstitutionTypeSaveAction) => {
                return institutiontypesApi
                    .setInstitutionType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionTypeEpic = (action$): Observable<IInstitutionTypeCreateSuccessAction | IInstitutionTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONTYPES_CREATE)
            .mergeMap((_action: IInstitutionTypeCreateAction) => {
                return institutiontypesApi
                    .createInstitutionType()
                    .map(response =>
                        CreateSuccess(
                            response.institutionType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionTypeEpic = (action$): Observable<IInstitutionTypeValidateSuccessAction | IInstitutionTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONTYPES_VALIDATE)
            .mergeMap((action: IInstitutionTypeValidateAction) => {
                return institutiontypesApi
                    .validateInstitutionType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



